import "./StatusPage.css";
import React from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../components/common/Header/Header";
import PageTitle from "../../components/common/PageTitle/PageTitle";
import usePermissionCheck from "../../hooks/usePermissionCheck";

// One layout for the pages that stand in for content: not found, access denied, an error.
// A code, a title and a line of explanation on a centred card, with a way back home.

const isColdTub = () => {
    const brand = localStorage.getItem('data-brand');
    if (brand) return brand === 'coldtub';
    return window.location.hostname.includes('mycoldtub');
};

interface StatusPageProps {
    // Shown as the eyebrow (e.g. "404") and in the browser tab
    code: string;
    title: string;
    message: React.ReactNode;
    icon: React.ReactNode;
    // Extra actions beside the home button
    actions?: React.ReactNode;
    // Hide the home button (e.g. when the session is gone and only Log in applies)
    withHome?: boolean;
}

const StatusPage: React.FC<StatusPageProps> = ({code, title, message, icon, actions, withHome = true}) => {
    const navigate = useNavigate();
    const {canAccess:canAccessAdminPanel} = usePermissionCheck(["view_dashboard"]);
    const baseTitle = isColdTub() ? "My COLDTUB™" : "My Arctic Spas";
    const home = canAccessAdminPanel ? "/home" : "/my-spas";

    return (
        <div className="page sp-page">
            <PageTitle title={`${code} ${title} | ${baseTitle}`}/>
            <Header/>
            <main className="sp-main">
                <section className="sp-card" aria-labelledby="sp-title">
                    <div className="sp-icon" aria-hidden="true">{icon}</div>
                    <span className="sp-code">{code}</span>
                    <h1 id="sp-title" className="sp-title">{title}</h1>
                    <p className="sp-message">{message}</p>
                    <div className="sp-actions">
                        {withHome &&
                            <a href={home} className="btn btn-primary" onClick={(e) => { e.preventDefault(); navigate(home); }}>
                                Go to Home
                            </a>}
                        {actions}
                    </div>
                </section>
            </main>
        </div>
    );
};

export default StatusPage;
